import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "../store";
import axios from "axios";

class AreaService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getAll() {
        return Vue.axios.get(`${APIHOST}/api/area`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new AreaService()